import Vue from 'vue';
import FullSlideImage from '@/components/SlideTemplates/basic/FullSlideImage.vue';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueMaterial);
Vue.component('FullSlideImage', FullSlideImage);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
